import { UserAddOutlined } from '@ant-design/icons'
import ButtonComponent from '@BUP/components/Generics/Buttons/button-component'
import ModalComponent from '@BUP/components/Generics/Modal'
import BupSpinner from '@BUP/components/Loading/Spinner'
import AddUserTeacherForm from '@BUP/components/MySchool/AddUserTeacherForm'
import { useCreateTeacherRegistrations } from '@BUP/hooks/registration/useCreateTeacherRegistrations'
import { useCreateEnrollment } from '@BUP/hooks/user/useCreateEnrollment'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './add-teacher-button.module.scss'

const AddTeacherButton = ({ courses, isMultiCourse }) => {
  const i18n = useTranslation()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [courseId, setCourseId] = useState(null)

  const {
    createEnrollment,
    error,
    setError,
    loading: loadingCreateEnrollment
  } = useCreateEnrollment()

  const { createRegistration, loadingRegistration: loadingCreateRegistration } =
    useCreateTeacherRegistrations({
      onSuccess: () => {
        setIsModalOpen(false)
        setCourseId(null)
      }
    })

  const handleCloseModalCreation = () => {
    setError(null)
    setIsModalOpen(false)
    setCourseId(null)
  }

  const handleCreateTeacher = async formValues => {
    const enrollment = await createEnrollment(formValues)
    if (enrollment && courseId) {
      await createRegistration(enrollment.id, courseId)
    } else if (enrollment) {
      setIsModalOpen(false)
      setCourseId(null)
    }
  }

  if (loadingCreateRegistration) return <BupSpinner size='small' />

  return (
    <>
      <ButtonComponent
        colorType='secondary'
        buttonText={<UserAddOutlined className={styles.icon} />}
        onClick={() => setIsModalOpen(true)}
      />
      <ModalComponent
        header
        headerText={i18n.t('common.resources.user.actions.add.submit')}
        modalDescription={
          <AddUserTeacherForm
            createEnrollment={handleCreateTeacher}
            courses={courses}
            loading={loadingCreateEnrollment}
            error={error}
            setCourseId={setCourseId}
            isMulticourse={!!isMultiCourse}
          />
        }
        stateModal={isModalOpen}
        showButtons={false}
        onClickCloseModal={handleCloseModalCreation}
      />
    </>
  )
}

export default AddTeacherButton
